import React from 'react';
import { OFFER_ANCHOR, PRODUCT_IMG } from './constants';
const modules = [{
  num: '1',
  title: 'SMART HOME INDUSTRY & CAREER FOUNDATIONS™',
  paragraphs: ['Understand residential automation, essential tools, safety, networking, communication protocols, project planning, professional workflows, and the services Smart Home installers can offer.']
}, {
  num: '2',
  title: 'PROFESSIONAL INSTALLATION FUNDAMENTALS™',
  paragraphs: ['Learn device selection, electrical and wiring fundamentals, equipment placement, power requirements, network preparation, compatibility, and professional installation practices.']
}, {
  num: '3',
  title: 'HOME ASSISTANT PROFESSIONAL SYSTEM™',
  paragraphs: ['Set up and manage Home Assistant, integrations, devices, dashboards, users, backups, remote access, system maintenance, and common troubleshooting.']
}, {
  num: '4',
  title: 'SMART DEVICES & AUTOMATION PROJECTS™',
  paragraphs: ['Move from individual devices to complete Smart Home systems.', 'Learn how lighting, sensors, relays, locks, climate, security, blinds and other devices work together through residential layouts, automation logic, system architectures, and complete project examples.']
}, {
  num: '5',
  title: 'PROFESSIONAL TROUBLESHOOTING & SYSTEM DELIVERY™',
  paragraphs: ['Diagnose connectivity, device, network, integration, and automation problems. Learn to test, optimize, document, and professionally deliver completed Smart Home systems.']
}, {
  num: '6',
  title: 'SMART HOME BUSINESS BLUEPRINT™',
  paragraphs: ['Learn how to structure services, create packages and quotations, communicate with clients, document projects, build your portfolio, market your services, and manage projects from first contact to final delivery.']
}];
const promises = ['Understand complete Smart Home systems.', 'Plan professional residential installations.', 'Build coordinated automations.', 'Complete practical Smart Home projects.', 'Troubleshoot and deliver systems professionally.', 'Learn how to structure your services.'];
export function SystemSection() {
  return <section className="bg-white px-4 py-5" data-id="element-162" data-mp="23z1n6ry5y2ra">
      <div className="mx-auto max-w-4xl" data-id="element-163" data-mp="240crqtzfnejg">
        <div className="mb-3 text-center" data-id="element-164" data-mp="241e5553x8d4c">
          <p className="mb-1 font-display text-[11px] font-semibold uppercase tracking-widest text-brand-orange sm:text-sm" data-id="element-165" data-mp="1z79vuf76nt03">
            The Complete System You've Been Looking For
          </p>
          <h2 className="mb-1 font-display text-xl font-extrabold uppercase leading-tight sm:text-3xl" data-id="element-166" data-mp="1paduqujm695k">
            One Complete 6-in-1 Smart Home Installation System
          </h2>
          <div className="mb-2 inline-block rounded-lg bg-brand-graphite px-3 py-1.5 text-white shadow-md" data-id="element-167" data-mp="1g97gks4ftafh">
            <p className="font-display text-xs font-bold tracking-wide sm:text-base" data-id="element-168" data-mp="1baw6qhe56zx9">
              SMART HOME INSTALLER PRO™ — Complete Installation &amp; Business System
            </p>
          </div>
          <p className="mx-auto max-w-3xl text-sm font-normal leading-snug text-brand-muted sm:text-base" data-id="element-169" data-mp="35o41k924bbiw">
            This isn't another collection of disconnected Smart Home theory. It's a structured system
            that takes you from understanding the technology to planning installations, building
            automations, troubleshooting systems, delivering projects, and learning how to offer the
            service professionally.
          </p>
          <ul className="mx-auto mt-1 flex max-w-3xl flex-wrap items-center justify-center gap-x-3 gap-y-0.5 text-xs font-semibold text-brand-ink sm:text-sm" data-id="element-170" data-mp="3rynbc0fz7lcf">
            {promises.map(promise => <li key={promise} data-id="element-171" data-mp="2z8dngxyul1dd">✔ {promise}</li>)}
          </ul>
        </div>

        <div className="grid gap-2.5 sm:grid-cols-2" data-id="element-172" data-mp="346f7pm80f6qf">
          {modules.map(module => <a key={module.num} href={OFFER_ANCHOR} className="group flex cursor-pointer gap-3 rounded-xl border border-brand-line bg-brand-light p-3 shadow-sm transition-all hover:border-brand-orange hover:shadow-md" data-id="element-173" data-mp="396l23a5nz7c7">
              <div className="flex h-9 w-9 shrink-0 items-center justify-center rounded-lg bg-brand-graphite font-display text-sm font-extrabold text-white transition-colors group-hover:bg-brand-orange" data-id="element-174" data-mp="oer97mdcl65i">
                {module.num}
              </div>
              <div data-id="element-175" data-mp="vzlcd30cgjrd">
                <h3 className="font-display text-[13px] font-bold leading-tight text-brand-ink sm:text-base" data-id="element-176" data-mp="vzv713wc3f3e">
                  ✅ {module.title}
                </h3>
                {module.paragraphs.map(paragraph => <p key={paragraph} className="mt-0.5 text-xs font-normal leading-snug text-brand-muted sm:text-sm" data-id="element-177" data-mp="14zhyoxz9h6j9">
                    {paragraph}
                  </p>)}
              </div>
            </a>)}
        </div>

        <div className="mt-4 text-center" data-id="element-178" data-mp="1eorr6ey0or7w">
          <a href={OFFER_ANCHOR} className="inline-block cursor-pointer" aria-label="Go to the offer" data-id="element-179" data-mp="1erxj01y1677b">
            
          </a>
        </div>
      </div>
    </section>;
}